import { IconButton } from '../icon-button/IconButton';
import { withPersonalizedIconButtonStyle } from '../icon-button/withPersonalizedIconButtonStyle';
import { styles } from './IconQuaternaryOnDarkButton.styles';

export const IconQuaternaryOnDarkButton = withPersonalizedIconButtonStyle(IconButton, styles);
